export { BottomPageControlsWrapper } from './BottomPageControlsWrapper';
